import { Component, computed, input } from '@angular/core';

@Component({
  selector: 'umss-splash-screen',
  imports: [],
  templateUrl: './splash-screen.component.html',
  styleUrl: './splash-screen.component.scss'
})
export class UmssSplashScreenComponent {
  app = input<
    'contractor' | 'business' | 'corporation' | 'facility' | 'corporate'
  >('facility');

  protected backgroundColor = computed(() => {
    return `var(--bg-sidebar-${this.app()})`;
  });
}
